import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStaff } from '../types/IStaff';
import IEvent from '../types/Ticket/IEvent';

const initialState = {
} as IEvent;

const EventSlice = createSlice({
    name: 'emailAction',
    initialState,
    reducers: {
        setEventNotes(state, action: PayloadAction<string>) {
            state.Notes = action.payload;
        },
        setEventTo(state, action: PayloadAction<IStaff[]>) {
            state.To = action.payload;
        },
        setStart(state, action: PayloadAction<string>) {
            state.StartDate = action.payload;
        },
        setEnd(state, action: PayloadAction<string>) {
            state.EndDate = action.payload;
        },
        setEventTicketId(state, action: PayloadAction<number>) {
            state.TicketId = action.payload;
        },
        setAllDay(state, action: PayloadAction<boolean>) {
            state.AllDay = action.payload;
        },
        resetEventForm(state, action: PayloadAction<IEvent>) {
            // Reset the form to the initial state
            //state = action.payload;
            state.Notes = '';
            state.AllDay = false;
            //console.log('Resetting event form', state);

        },
    },
});

export const { setEventNotes, setEventTo, resetEventForm, setEventTicketId, setStart, setEnd, setAllDay } = EventSlice.actions;

export default EventSlice.reducer;

